import _default from './Breadcrumb';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ../node_modules/semantic-ui-react/dist/es/collections/Breadcrumb/index.js
// module id = 847
// module chunks = 0